export const iconFontAwesomeNatureClover = (
	<i className="fa-solid fa-clover"></i>
);
